import { render, staticRenderFns } from "./SectionPayment.vue?vue&type=template&id=5a87c6a9&scoped=true&"
import script from "./SectionPayment.vue?vue&type=script&lang=ts&"
export * from "./SectionPayment.vue?vue&type=script&lang=ts&"
import style0 from "./SectionPayment.vue?vue&type=style&index=0&id=5a87c6a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87c6a9",
  null
  
)

export default component.exports